  <div class="background" >
    
    <div class="messageInsets">
      <h1>Messages</h1>
      <div 
        [@allMessages]=allMessagesTrigger 
        (@allMessages.done)="openConversationEnd($event)" 
        style="width: 100%">
        <app-volunteer 
          authLevel="{{authLevel}}"
          entityId="{{entityId}}"
          uid="{{profile?.uid}}"
          [reload]=allMessagesTrigger 
          (choice)="openConversation($event)">
        </app-volunteer>
      </div>
      <div 
        
        [@expandedMessage]=expandedMessageTrigger 
        (@expandedMessage.done)="closeConversationEnd($event)">
        <app-single-message 
          *ngIf="expandedMessageTrigger === 'expandedMessage'"
          authLevel="{{authLevel}}"
          entityId="{{entityId}}"
          uid="{{profile?.uid}}"
          [conversationSubject]=selectedConversationSubject 
          (openProfile)="openProfile($event)"
          (close)="closeConversation()">
        </app-single-message>
      </div>
      <div *ngIf="authLevel" [@profile]=profileTrigger>
        <app-profile [id]=selectedProfile (close)="closeProfile()"></app-profile>
      </div>
    </div>
</div>